const state = {
  stats: [],
  meta_data: {}
}

export default state
